import ThreeByOneUnit, { ThreeByOneUnitProps } from './ThreeByOneUnit';

export default ThreeByOneUnit;
export type { ThreeByOneUnitProps };
